import { render, staticRenderFns } from "./TipsOne.vue?vue&type=template&id=bd4e7fb8&scoped=true&"
import script from "./TipsOne.vue?vue&type=script&lang=js&"
export * from "./TipsOne.vue?vue&type=script&lang=js&"
import style0 from "./TipsOne.vue?vue&type=style&index=0&id=bd4e7fb8&scoped=true&lang=less&"
import style1 from "./TipsOne.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e7fb8",
  null
  
)

export default component.exports